import UserSingleSelect from "@/components/form/user-single-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import { UserRole } from "@/types/openapi-enum";

type ManagerFieldExtraProps = {
  placeholder?: string;
  align?: "start" | "center" | "end";
};

/** Searchable manager picker. **Value is a user id** (`string | null`). */
export type ManagerFieldProps = PickerFieldProps<
  string | null,
  ManagerFieldExtraProps
>;

export const ManagerField = makePickerField<
  string | null,
  ManagerFieldExtraProps
>({
  name: "ManagerField",
  control: UserSingleSelect,
  popout: true,
  controlProps: (props) => ({
    params: { roles: UserRole.Manager, isActivated: "true" },
    placeholder: props.placeholder,
    align: props.align,
  }),
});
